import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import LetterNumberOrder from './LetterNumberOrder';
import GET_WDT_CLASSROOM_SETTINGS from 'graph/settings/wdt/get-wdt-classroom-settings-query';
import { Classroom } from 'types/schema-generated-types';

interface WdtSettingsProps {
  classroom: Classroom;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const ClassroomWdtSettings: FC<WdtSettingsProps> = ({
  classroom,
  expanded,
  handleChangeExpanded
}) => {
  const { id: classroomId } = classroom;
  const { data, loading } = useQuery(GET_WDT_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: +classroomId
      }
    }
  });

  return (
    <PageContainer loading={loading}>
      <LetterNumberOrder
        classroom={classroom}
        setting={data?.wdtClassroomSettings.characterOrder}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default ClassroomWdtSettings;
